import { List } from 'immutable';
import Agreement from '../../../interfaces/output/agreement';
import { ensure } from '../../../utils/arrayUtils';
import LanguageUtils from '../../../utils/LanguageUtils';
import ValidationModel from '../../../utils/validationModel';
import ValidationUtils from '../../../utils/validationUtils';

const messages = {
    requiredFields: LanguageUtils.createMessage('Validation error general'),
    specialCharatersNotAllowd: LanguageUtils.createMessage('Special characters not allowd')
};

export default class AgreementStep1Validation extends ValidationUtils {

    static validateAgreementForm(agreement: Agreement): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;

        const { name
        } = agreement;

        const requiredFields =
            this.validateInputStringLength(name);

        const inputStringSpecialCharacters =
            this.validateInputStringSpecialCharacters(name);

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        if(!inputStringSpecialCharacters) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.specialCharatersNotAllowd);
        }

        return validationModel;
    }
}